<script setup lang="ts">
import type { MLoadRef } from '~/components/m/MLoad.vue'

definePageMeta({
  layout: 'account-center'
})

const id = Number(useRoute().params.id?.toString())

const empty = ref(false)
const loaded = ref(false)
const list = ref<Feed.Info[]>([])
const loadRef = ref<MLoadRef>()

onMounted(async () => {
  await load()
})

async function load() {
  const res = await fetchFeedList({ userId: id })
  empty.value = res.length === 0
  list.value = res
  loaded.value = true
  loadRef.value?.check()
}

async function loadMore(ev: { complete: () => void }) {
  if (empty.value || !loaded.value) {
    ev.complete()
    return
  }
  const lastId = list.value[list.value.length - 1]?.id || 0
  const more = await fetchFeedList({ userId: id, startId: lastId })
  empty.value = more.length === 0
  list.value.push(...more)
  ev.complete()
}
</script>

<template>
  <MContainer class="m-feed-list">
    <div v-for="f in list" :key="f.id" class="m-feed-list-item">
      <MFeedCard :feed="f" />
    </div>
    <MLoad ref="loadRef" :empty="empty" @on-scroll-end="loadMore" />
  </MContainer>
</template>

<style lang="scss" scoped>
.m-feed-list {
  &-item {
    padding: 0 30px;
    margin-top: 24px;
    margin-bottom: 24px;
    border-bottom: 1px solid var(--color-gray-200);
  }
}
</style>
